/**
 * Gravity Forms — Tap-to-Rank Activity Cards (frontend)
 *
 * For each field container carrying [data-ct-rank-cards] (added by
 * extensions/gravity-forms-rank-cards/functions.php):
 * - First tap marks a card as choice 1, second tap as choice 2.
 * - Tapping a third card replaces the 2nd choice and keeps the 1st.
 * - Tapping a selected card deselects it; #2 promotes to #1 automatically.
 * - The ordered choice values are written into the two linked GF Hidden
 *   fields, which are the canonical entry data (validated server-side).
 *
 * State survives failed-validation AJAX re-renders: GF repopulates the
 * hidden inputs from POST and we rebuild the selection from them.
 */
(function () {
  function initAll() {
    document.querySelectorAll('[data-ct-rank-cards]').forEach(initField);
  }

  function initField(fieldEl) {
    if (fieldEl.dataset.ctRankInit === '1') return;
    fieldEl.dataset.ctRankInit = '1';

    var formId = fieldEl.getAttribute('data-ct-rank-form');
    var firstInput = document.getElementById('input_' + formId + '_' + fieldEl.getAttribute('data-ct-rank-first'));
    var secondInput = document.getElementById('input_' + formId + '_' + fieldEl.getAttribute('data-ct-rank-second'));
    if (!firstInput || !secondInput) return;

    var cards = Array.prototype.slice.call(fieldEl.querySelectorAll('.gchoice'));
    if (!cards.length) return;

    var status = buildStatusLine();

    // order[0] = 1st choice card, order[1] = 2nd choice card
    var order = restore();
    sync();

    fieldEl.addEventListener('click', function (event) {
      var card = event.target.closest('.gchoice');
      // Let real links work, and let the "View moderator prompts" button open
      // its modal (handled in main.js) without toggling the card selection.
      if (!card || event.target.closest('a') || event.target.closest('.ct-rank-card__prompts')) return;
      event.preventDefault(); // suppress native checkbox/label toggling
      toggle(card);
    });

    function inputOf(card) {
      return card.querySelector('input[type="checkbox"], input[type="radio"]');
    }

    function valueOf(card) {
      var input = inputOf(card);
      return input ? input.value : '';
    }

    function labelOf(card) {
      var label = card.querySelector('label');
      return label ? label.textContent.trim() : valueOf(card);
    }

    /**
     * Rebuild the ordered selection from the hidden field values (set by GF
     * from POST after a failed validation). Falls back to checked inputs.
     */
    function restore() {
      var byValue = {};
      cards.forEach(function (card) {
        byValue[valueOf(card)] = card;
      });

      var restored = [];
      [firstInput.value, secondInput.value].forEach(function (value) {
        var card = value && byValue[value];
        if (card && restored.indexOf(card) === -1) restored.push(card);
      });

      if (!restored.length) {
        cards.forEach(function (card) {
          var input = inputOf(card);
          if (input && input.checked && restored.length < 2) restored.push(card);
        });
      }

      return restored;
    }

    function toggle(card) {
      var index = order.indexOf(card);
      if (index > -1) {
        order.splice(index, 1); // deselect; remaining card promotes to #1
      } else if (order.length >= 2) {
        order.splice(1, 1, card); // replace the 2nd choice, keep the 1st
      } else {
        order.push(card);
      }
      sync();
    }

    function sync() {
      cards.forEach(function (card) {
        var position = order.indexOf(card);
        var input = inputOf(card);
        var badge = card.querySelector('.ct-rank-card__badge');

        if (position > -1) {
          card.setAttribute('data-ct-rank', String(position + 1));
          if (badge) badge.textContent = String(position + 1);
          if (input) input.checked = true;
        } else {
          card.removeAttribute('data-ct-rank');
          if (badge) badge.textContent = '';
          if (input) input.checked = false;
        }
      });

      firstInput.value = order[0] ? valueOf(order[0]) : '';
      secondInput.value = order[1] ? valueOf(order[1]) : '';
      updateStatus();
    }

    function buildStatusLine() {
      var container = fieldEl.querySelector('.ginput_container');
      var el = document.createElement('div');
      el.className = 'ct-rank-status';
      el.setAttribute('aria-live', 'polite');

      var choices = document.createElement('span');
      choices.className = 'ct-rank-status__choices';

      var hint = document.createElement('span');
      hint.className = 'ct-rank-status__hint';
      hint.textContent = 'Tap a selected card to undo.';

      el.appendChild(choices);
      el.appendChild(hint);
      (container || fieldEl).insertAdjacentElement('afterend', el);

      return { el: el, choices: choices };
    }

    function appendChoice(parent, prefix, value) {
      parent.appendChild(document.createTextNode(prefix));
      var strong = document.createElement('strong');
      strong.textContent = value;
      parent.appendChild(strong);
    }

    function updateStatus() {
      status.choices.textContent = '';
      appendChoice(status.choices, '1st choice: ', order[0] ? labelOf(order[0]) : '—');
      appendChoice(status.choices, ' · 2nd choice: ', order[1] ? labelOf(order[1]) : '—');
    }
  }

  document.addEventListener('DOMContentLoaded', initAll);

  // GF AJAX re-renders the form after failed validation (forms layout embeds
  // with $ajax = true) — re-init on every render.
  if (window.jQuery) {
    jQuery(document).on('gform_post_render', function () {
      initAll();
    });
  }
})();
